<template>

  <EntityManager
      heading="Продукти"
      heading-create="Нов продукт"
      heading-modify="Редактиране на продукт"
      heading-delete="Изтриване на продукт"
      message-delete="Избраният продукт ще бъде изтрит. Сигурни ли сте?"
      resource="/product">
    <template #table>
      <Column field="number" header="Номер" style="flex: 0 0 10em"/>
      <Column field="name" header="Наименованние" headerStyle="width: 21em"/>
      <Column field="category.name" header="Продуктова група" style="flex: 0 0 20em"/>
      <Column field="priceWholesale" header="Цена на едро (без ДДС)" style="flex: 0 0 10em" bodyClass="right">
        <template #body="props">
          {{$utils.currency(props.data.priceWholesale)}}
        </template>
      </Column>
      <Column field="priceRetail" header="Цена на дребно (с ДДС)" style="flex: 0 0 10em" bodyClass="right">
        <template #body="props">
          {{$utils.currency(props.data.priceRetail)}}
        </template>
      </Column>
      <Column field="quantity" header="Наличност" style="flex: 0 0 10em" bodyClass="right"/>
    </template>
    <template v-slot:form="props">
      <div class="p-fluid p-grid" style="width: 600px">
        <div class="p-field p-col-12 p-md-9">
          <label for="name">Наименование</label>
          <InputText id="name" type="text" v-model.trim="props.entity.name" class="{ 'p-invalid': submitted && !item.name }"/>
          <small class="p-invalid" v-if="props.submitted && !props.entity.name">Полето е задължително.</small>
        </div>
        <div class="p-field p-col-12 p-md-3">
          <label for="number">Каталожен номер</label>
          <InputText id="number" v-model="props.entity.number" />
        </div>
        <div class="p-field p-col-12 p-md-10 p-input-filled">
          <label for="category">Група</label>
          <AutoComplete v-model="props.entity.category" :dropdown="true" field="name"
            :suggestions="categories" @complete="searchCategory($event)" placeholder="Въведете група"/>
        </div>
        <div class="p-field p-col-12 p-md-2">
          <label for="measure">Мярка</label>
          <InputText id="measure" v-model="props.entity.measure" />
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="price">Цена на едро</label>
          <InputNumber id="price" v-model="props.entity.priceWholesale" mode="decimal" :minFractionDigits="2"/>
        </div>
        <div class="p-field p-col-12 p-md-4">
          <label for="price">Цена на дребно</label>
          <InputNumber id="price" v-model="props.entity.priceRetail" mode="decimal" :minFractionDigits="2"/>
        </div>
      </div>
    </template>
    <template #buttons-right>
      <Button
          label="Импортирай"
          icon="pi pi-upload"
          class="p-button-secondary"
          @click="onImport()"
      />
    </template>
  </EntityManager>
  <ProductsImporter ref="importer" v-model:visible="importerVisible" @close="this.loadData"/>

</template>

<script>

export default {
  data() {
    return {
      categories: [],
      importerVisible : false
    }
  },

  created() {
  },

  methods: {
    onRead(event) {
      event.onSuccess(event.item);
    },
    onImport() {
      this.importerVisible = true;
      this.$refs.importer.open();
    },
    searchCategory(event) {
      var ctx = this;
      this.$http.get('/product-category', {
        params: {
          query: event.query
        }
      }).then(res => ctx.categories = res.data)
    },
    onDelete(event) {
      event.onFailure("Елементът се използва.");
    },
    csvImport() {
    },
    onSave(event) {
      if (event.item.id) {
        this.$http.put('/product', event.item)
          .then(event.onSuccess)
          .catch(function(response) {
            alert(response)
            event.onFailure(response)
          });
      } else {
        this.$http.post('/product', event.item)
          .then(event.onSuccess)
          .catch(function(response) {
            alert(response)
            event.onFailure(response)
          });
      }
    }
  }
}
</script>

<style>
</style>
